import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
// creating private route 
const PrivateRoute = ({ children, ...rest }) => {
    const { user } = useAuth();
    return (
        // redirecting to login page 
        <Route
            {...rest}
            render={({ location }) => user.displayName ?
                children :
                <Redirect
                    to={{
                        pathname: '/login',
                        state: { from: location }
                    }}
                >
                </Redirect>
            }
        >
        </Route>
    );
};

export default PrivateRoute;